+function ($) {
    'use strict';

    var NumbersHelper = {
        isInt : function (param) {
            return !isNaN(parseInt(param));
        },
        asInt : function(param) {
            if (!this.isInt(param)) throw "NumbersHelper.isInt value is not int";

            return parseInt(param, 10);
        }
    };

    var DateHelper = {
        /**
         * Преборазует строку в формате dd*mm*yyyy в объект Date,
         * где * - является символом разделителем
         * @param $param
         * @param $delimiter
         * @return Date()
         */
        strToDate : function (param, delimiter) {
            if (delimiter == undefined) {
                delimiter = '.'
            }

            param = param.split(delimiter);

            if (param.length != 3) throw 'DateHelper.strDateToDate date string is not correct';

            param[0] = $.NumberHelper.asInt(param[0]);
            param[1] = $.NumberHelper.asInt(param[1]);
            param[2] = $.NumberHelper.asInt(param[2]);

            return new Date(param[2], param[1]-1, param[0]);
        },
        /**
         * Добавляет количество дней к дате
         *
         * @param days
         * @param Date
         */
        addDaysToDate : function (days, date) {
            if (typeof (date) !== 'object') throw 'DateHelper.addDaysToDate date is not a Date object';
            if (!$.NumberHelper.isInt(days)
                || $.NumberHelper.asInt(days) < 0) throw 'DateHelper.addDays days parameter is not correct';

            var curDay = date.getDate();
            var curMonth = date.getMonth();
            var curYear = date.getFullYear();
            var changedDay = new Date(curYear, curMonth, curDay);

            curDay += days;

            changedDay.setDate(curDay);

            return changedDay;
        },

        /**
         * Сравнивает даты в формате dd.mm.YYYY без учета времени
         * Когда даты dateOne и dateTwo равны возвращает 0
         * Когда дата dateOne > dateTwo возвращает 1
         * Когда дата dateOne < dateTwo возвращает -1
         * @param dateOne
         * @param dateTwo
         */
        compareDates : function(dateOne, dateTwo) {
            if (typeof(dateOne) !== 'object') throw 'DateHelper.compareDates dateOne is not a Date object';
            if (typeof(dateTwo) !== 'object') throw 'DateHelper.compareDates dateTwo is not a Date object';

            var dayOne   = dateOne.getDate();
            var monthOne = dateOne.getMonth();
            var yearOne  = dateOne.getFullYear();

            var dayTwo   = dateTwo.getDate();
            var monthTwo = dateTwo.getMonth();
            var yearTwo  = dateTwo.getFullYear();

            if (yearOne > yearTwo) return 1;
            if (yearOne < yearTwo) return -1;

            if (monthOne > monthTwo) return 1;
            if (monthOne < monthTwo) return -1;

            if (dayOne > dayTwo) return 1;
            if (dayOne < dayTwo) return -1;

            return 0;
        }

    };

    $.NumberHelper = NumbersHelper;
    $.DateHelper = DateHelper;
}(jQuery);